module.exports = "/assets/data/0db218c54e17ed3f430422f7874f11ee-KT3.data.json";